import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  profilePictureUrl?: string | null;
  name: string;
  initials: string;
  className?: string;
}

/**
 * A user's avatar: their profile picture when set, otherwise their initials.
 */
export function UserAvatar({
  profilePictureUrl,
  name,
  initials,
  className,
}: UserAvatarProps) {
  return (
    <Avatar className={cn("h-8 w-8", className)}>
      {profilePictureUrl && <AvatarImage src={profilePictureUrl} alt={name} />}
      <AvatarFallback className="bg-primary/10 text-xs font-medium text-primary">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
